import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from '../../../services/chat-service/types';
import { AssetCardList } from '../../../shared/asset-card-list';
import { AssetListRequestQueryParams } from '../../../services/asset-service/types';
import { marked } from 'marked';
import { ChatFeedback } from './chat-feedback/chat-feedback';
import { BotReasoning } from './bot-reasoning';

@Component({
  selector: 'bot-text-bubble',
  template: `
    <bot-reasoning [message]="message()" />
    <div class="bot-message" [innerHtml]="html()" (click)="onMessageClick($event)"></div>
    @if (haveAssets()) {
      <asset-card-list [assetListParams]="assetListParams()" />
    }
    @if (!thinking()) {
      <chat-feedback [botResponse]="message()" [chatId]="chatId()" />
    }
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    div.bot-message {
      color: var(--text-dark);
      font-size: 14px;
      line-height: 1.65;
    }
  `,
  imports: [AssetCardList, ChatFeedback, BotReasoning],
})
export class BotTextBubble {
  private router = inject(Router);

  readonly message = input.required<Message>();
  readonly chatId = input.required<string>();

  // Still waiting for the answer (feedback is hidden until it starts).
  readonly thinking = computed(() => !!this.message().steps && !this.message().content);

  readonly haveAssets = computed(() => {
    return this.message().recommended_assets.length > 0;
  });
  readonly assetListParams = computed(() => {
    const params: AssetListRequestQueryParams = {
      asset_ids: this.message().recommended_assets,
    };
    return params;
  });

  html = computed(() => {
    return marked.parse(this.message().content);
  });

  // Route in-app links in the bot's markdown (e.g. /catalog) through the router
  // instead of letting the browser reload the whole app.
  onMessageClick(event: MouseEvent) {
    const href = (event.target as HTMLElement).closest('a')?.getAttribute('href');
    if (href?.startsWith('/')) {
      event.preventDefault();
      this.router.navigateByUrl(href);
    }
  }
}
